import { Injectable } from '@angular/core';

import { CrudApiBaseService } from './crud-api.base';

@Injectable({ providedIn: 'root' })
export class RegionApi extends CrudApiBaseService<any> {
  endpoint = 'region';
}
